import Util from './util.js'
import store from './store'

let lastChild = null

function _calcProgressBar() {

	if (!store.state.progressBarEnabled) {
		this.style = {
			'transition-duration': '0s',
			'transform': 'scaleX(0)'
		}
		return
	}

	Vue.nextTick(() => {

		let stickies = this.$root.$refs['sticky-header'] || []

		// Loop through all headers
		for (var i = 0; i < stickies.length; i++) {

			let child = stickies[i]

			// If it is in viewport...
			if (child.belowViewport == true) {

				// Get progress bar length
				this.value = 1 - child.progress
				this.style = {
					'background-color': child.color,
					'transform': 'scaleX(' + this.value + ')'
				}

				// Disable transition duration when switching
				if (lastChild != child) {
					if(lastChild == stickies[i - 1]) {
						this.style = {
							'transition-duration': '0s',
							'transform': 'scaleX(0)'
						}
					} else {
						// this.style = {
						// 	'transition-duration': '0s',
						// 	'transform': 'scaleX(1)'
						// }
					}
					lastChild = child
				}

				store.commit('fixOutro', false)

				// Break loop
				break

			} else if(i == stickies.length - 1) {

				this.style = {
					'transition-duration': '0.5s',
					'transform': 'scaleX(1)',
					'opacity': 0
				}

				store.commit('fixOutro', true)

			}

		}

	})

}

let ProgressBar = Vue.component('progress-bar', {
	methods: {
		calcProgressBar: _calcProgressBar
	},
	mounted() {
		this.value = 0
		this.style = 'transform: scaleX(' + this.value + ')'
		Util.eventBus.$on('doScrollEvents', this.calcProgressBar)
	},
	computed: {
		scroll() {
			return store.state.scroll
		}
	},
	data: function() {
		return {
			value: 0,
			style: 'transform: scaleX(0)'
		}
	},
	template: `
		<div>
			<div class="progress-shadow"></div>
			<div class="progress" v-bind:style="this.style"></div>
		</div>`
})

export default ProgressBar
